// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { categoryDetailSubCategoriesStyles } from "@turnerBlueprint/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    gap: 22,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    css: css`
        ${({ isCategoryLevelOne }: any) => css`
            min-width: ${BLUEPRINT_NAME === "turnerScienceBlueprint" && !isCategoryLevelOne ? "152px" : "unset"};
        `}
    `,
};

categoryDetailSubCategoriesStyles.innerContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
        height: 100%;
    `,
};

categoryDetailSubCategoriesStyles.innerInformationContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        ${({ isCategoryLevelOne }: any) => css`
            flex-direction: ${BLUEPRINT_NAME === "turnerScienceBlueprint" && !isCategoryLevelOne ? "column" : "row"};
        `}
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    css: css`
        flex-shrink: 0;
        flex-grow: 0;
        ${({ isCategoryLevelOne }: any) => css`
            width: ${BLUEPRINT_NAME === "turnerScienceBlueprint" && !isCategoryLevelOne ? 152 : 64}px;
            height: ${BLUEPRINT_NAME === "turnerScienceBlueprint" && !isCategoryLevelOne ? 152 : 64}px;
        `}
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    css: css`
        width: 100%;
        height: 100%;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImage = {
    css: css`
        width: 100%;
        height: 100%;

        img {
            width: auto;
            height: auto;
            max-height: 100%;
            max-width: 100%;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    css: css`
        display: flex;
        flex-wrap: no-wrap;
        gap: 12px;
        margin-bottom: 6px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    typographyProps: {
        forwardAs: "p",
        size: 16,
        lineHeight: "17px",
        css: css`
            margin: 0;

            &&& {
                color: ${color("text.main")};

                &:hover {
                    color: ${color("common.ui9")};
                }
            }
        `,
    },
};

categoryDetailSubCategoriesStyles.subCategoryNameLinksListItem = {
    css: css`
        flex-basis: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkInner = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 13px;
        `,
    },
    css: css`
        align-self: baseline;
        color: ${color("text")};
        &:hover {
            color: ${color("common.ui9")};
        }
    `,
};

categoryDetailSubCategoriesStyles.viewAllLink = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
    },
    css: css`
        width: auto;
        ${IconWrapper},
        ${IconWrapper} svg {
            width: 11px;
        }
    `,
};
